import { render, staticRenderFns } from "./FeedItem.vue?vue&type=template&id=2b51da04&scoped=true&"
import script from "./FeedItem.vue?vue&type=script&lang=ts&"
export * from "./FeedItem.vue?vue&type=script&lang=ts&"
import style0 from "./FeedItem.scss?vue&type=style&index=0&id=2b51da04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b51da04",
  null
  
)

export default component.exports